<template>
  <div v-if="loans.length !== 0 || neverLoaded">
    <loans-table
      :captions="captions"
      :fields="fields"
      :filter-function="filterFunction"
      :format-function="formatFunction"
      :loans="loans"
      :sort-compare="sortCompare"
      @action-clicked="item => $emit('action-clicked', item)"
    >

      <template slot="header">
        <div class="text-left font-italic font-weight-bold">
          * Click on Loan to upload documents and see additional details
        </div>
      </template>
      <template slot="caption">
        <infinite-loading @infinite="fetch">
          <template slot="spinner">
            <spinner />
          </template>
          <template slot="no-more">No more deals.</template>
        </infinite-loading>
      </template>
    </loans-table>
  </div>
  <no-deals-found class="mt-3" v-else />
</template>


<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faExclamationTriangle, faPlusSquare } from '@fortawesome/free-solid-svg-icons';

import InfiniteLoading from 'vue-infinite-loading';
import LoansTable from '@/components/my_deals/deals/LoansTable';
import NoDealsFound from '@/components/my_deals/deals/NoDealsFound';
import Spinner from '@/components/utils/Spinner';

import IN_PROGRESS_FIELDS from '@/components/my_deals/resources/fields/inProgress.json';
import activeFields from '@/components/my_deals/resources/fields/active';
import PAID_FIELDS from '@/components/my_deals/resources/fields/paid.json';
import ALL_FIELDS from '@/components/my_deals/resources/fields/all.json';
import perms from '@/libs/permissions';

library.add([faExclamationTriangle, faPlusSquare]);


export default {
  components: {
    LoansTable,
    NoDealsFound,
    InfiniteLoading,
    Spinner,
  },
  props: {
    group: {
      type: String,
      required: true,
    },
    searchKey: String,
    searchValue: String,
    filterFunction: Function,
    sortCompare: Function,
    captions: Array,
    formatFunction: Function,
  },
  data() {
    return {
      amount: 0,
      lastId: null,
      loans: [],
      neverLoaded: true,
      pageSize: 10,
      total: 0,
      loading: true,
    };
  },
  computed: {
    fields() {
      const map = {
        in_progress: IN_PROGRESS_FIELDS,
        active: perms.checkPermissionsOnArray(activeFields.ACTIVE_FIELDS),
        paid: PAID_FIELDS,
        all: ALL_FIELDS,
      };

      return map[this.group];
    },
  },
  methods: {
    fetch($state) {
      const config = { pre: false, post: false, error: true };
      const params = {
        group: this.group,
        page_size: this.pageSize,
        last_id: this.lastId,
      };
      if (this.searchKey && this.searchValue) {
        params.search_key = this.searchKey;
        params.search_value = this.searchValue;
      }

      this.loading = true;
      this.$reqs.get(`users/${this.$store.getters.user.id}/loans`, params, config)
        .then((response) => {
          this.neverLoaded = false;

          const records = response.data.records;
          if (records.length) {
            this.$set(this, 'loans', Array.prototype.concat(this.loans, records));
            this.lastId = records[records.length - 1].id;
            this.total = response.data.total;
            this.amount += response.data.total_amount;
            this.$emit('total-loans-set', this.total);
            this.$emit('total-amount-set', this.amount);
            $state.loaded();
          } else {
            $state.complete();
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          $state.complete();
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/deals/LoansInfiniteTable.vue